export enum NameStore {
  ochkaric = 'Очкарик',
}
